import { fork } from 'redux-saga/effects';
import upcomingRequestPaginationSaga from './upcoming-surveys-pagination-saga';
import answeredRequestPaginationSaga from './answered-surveys-pagination-saga';
import sequentialSurveySaga from './sequential-survey-saga';

export default function* root() {
  yield fork(answeredRequestPaginationSaga);
  yield fork(upcomingRequestPaginationSaga);
  yield fork(sequentialSurveySaga);
}



// WEBPACK FOOTER //
// ./src/redux/surveys/sagas/index.js